import React from 'react';

export default function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-navy-nav/80 backdrop-blur-2xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="https://profitlense.ai/" className="flex items-center group cursor-pointer">
          <img 
            src="https://i.postimg.cc/PJHcFz0Z/Profit-Lense-Ai-removebg-preview.png" 
            alt="ProfitLense.ai" 
            className="h-8 md:h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-105" 
          />
        </a>
        <div className="flex items-center gap-4 md:gap-8">
          <div className="hidden md:flex items-center gap-8 mr-4">
            <a 
              href="https://profitlense.ai/" 
              className="text-sm font-medium text-text-body hover:text-white transition-colors"
            >
              Features
            </a>
            <a 
              href="https://buy.stripe.com/28EeV75zjdlv2hS6Cf7Vm01" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm font-medium text-text-body hover:text-white transition-colors"
            >
              Pricing
            </a>
            <a 
              href="https://profitlense.ai/our-interactive-guides/" 
              className="text-sm font-medium text-text-body hover:text-white transition-colors"
            >
              Guides
            </a>
          </div>
          <a 
            href="https://profitlense.ai/contact-us/" 
            className="text-[10px] md:text-sm font-bold text-white bg-brand-secondary/10 hover:bg-brand-secondary/20 border border-brand-secondary/30 px-4 md:px-6 py-2 md:py-2.5 rounded-xl transition-all whitespace-nowrap" 
          >
            Get Support
          </a>
        </div>
      </div>
    </nav>
  );
}